import { Loader } from "dash-styled"
import React, { FC } from "react"
import { selectUserName } from "../../../../../Helpers/Functions/Selectors/auth"
import { useAppState } from "../../../../../Hooks/useReduxState"
import { DashboardBase, DashboardBaseProps } from "./DashboardBase"

type BackofficeDashboardBaseProps = Omit<DashboardBaseProps, "orgUsername">

export const BackofficeDashboardBase: FC<BackofficeDashboardBaseProps> =
    props => {
        const myUsername = useAppState(selectUserName)

        if (myUsername === undefined) {
            return <Loader absolute={true} />
        }
        return <DashboardBase orgUsername={myUsername} {...props} />
    }
